import { render, staticRenderFns } from "./DocApprovisionnement.vue?vue&type=template&id=f821a102&"
import script from "./DocApprovisionnement.vue?vue&type=script&lang=js&"
export * from "./DocApprovisionnement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports